import { makeStyles } from "@material-ui/core";
import { NumericLiteral } from "typescript";
import { ObtenerToken, ObtenerTokenPostDec, ObtenerTokenEmail } from "../../../application/interactors/Postulante"



export const ObtenerTokenLogic = (selListaToken: any, rut: string, fechaNacimiento: Date) => {
  return ObtenerToken(selListaToken, rut, fechaNacimiento);
}
export const ObtenerTokenEmailLogic = (selListaToken: any, rut: string, correo: string) => {
  return ObtenerTokenEmail(selListaToken, rut, correo);
}
export const ObtenerTokenPostDecLogic = (selListaToken: any, data: any) => {
  return ObtenerTokenPostDec(selListaToken, data);
}
// export const GrabarDatosPostulanteLogic = (selGrabarPostulante: any, codigoNegocio: number,
//   rut: number,
//   dv: string,
//   nombres: string,
//   apPaterno: string,
//   apMaterno: string,
//   fechaNacimiento: Date,
//   idGenero: number,
//   genero: string,
//   telefono: string,
//   mail: string,
//   direccion: string,
//   idComuna: string,
//   comuna: string,
//   idPais: number,
//   nacionalidad: string) => {
//   return GrabarDatosPostulante(selGrabarPostulante, codigoNegocio, rut, dv, nombres, apPaterno, apMaterno,
//     fechaNacimiento, idGenero, genero, telefono, mail, direccion, idComuna, comuna, idPais, nacionalidad);
// }

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      margin: theme.spacing(1),
      width: theme.spacing(16),
      height: theme.spacing(10),
    },
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 300
  },
  formControlAlertMail: {
    margin: theme.spacing(1),
    minWidth: 100
  },
  alertMail: {
    width: '100%',
    // '& > * + *': {
    //   marginTop: theme.spacing(1),
    //   },
  },
  marginBotton: {
    margin: theme.spacing(3),
  },
  marginBottonGoogle: {
    margin: theme.spacing(1),
    width: '20rem',
    marginTop: -10
  },
  alertErrorGoogle: {
    root: {
      width: '100%',
      '& > * + *': {
        marginTop: theme.spacing(0),
      },
    },
  },
  rootPreguntas: {
    flexGrow: 1,
  },
  paperPreguntas: {
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  botonesPregunta: {
    padding: theme.spacing(0),
    textAlign: 'right',
    marginBottom: theme.spacing(5),
    //paddingLeft: theme.spacing(20)
  },
  panelCentral: {
    padding: theme.spacing(0),
    textAlign: 'center',
    marginBottom: theme.spacing(50),
  },
  alertPreguntas: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
  panelPreguntas: {
    '& > *': {
      margin: theme.spacing(1),
    },
    //textAlign: 'center',
  },
  formPreguntas: {
    '& > *': {
      margin: theme.spacing(5)
    },
  },
  rootPanelPreguntas: {
    flexGrow: 1,
  },
  paperPanelPreguntas: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}));